import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  fetchCollections,
  getCampaignProducts,
  getCollectionSKU,
  productService,
} from "../services/ProductsService";

export const useAllSKU = (campaignCode, size = 20, collectionId, searchTerm) => {
  return useInfiniteQuery({
    queryKey: ["allSKU", campaignCode, collectionId, searchTerm],
    queryFn: ({ pageParam = 1 }) =>
      getCampaignProducts(campaignCode, pageParam, size, collectionId, searchTerm),
    getNextPageParam: (lastPage) => {
      if (lastPage?.hasNextPage) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    enabled: !!campaignCode,
    keepPreviousData: true,
  });
};



// Hook for specific category
export const useCollectionSKU = (campaignCode, collectionId, size = 20,searchTerm) => {
  return useInfiniteQuery({
    queryKey: ["collectionSKU", campaignCode, collectionId],
    queryFn: ({ pageParam = 1 }) =>
      getCollectionSKU(campaignCode, collectionId, pageParam, size,searchTerm),
    getNextPageParam: (lastPage) => {
      if (lastPage?.hasNextPage) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    enabled: !!campaignCode && !!collectionId,
  });
};


//One hook for all cases
export const useSKU = (
  campaignCode,
  collectionId = null,   // null → means All Products
  brandCampaignId,
  size = 10,
  searchTerm = ""
) => {
  return useInfiniteQuery({
    queryKey: ["sku", campaignCode, collectionId,brandCampaignId, searchTerm],
    queryFn: ({ pageParam = 1 }) =>
      getCampaignProducts(campaignCode, pageParam, size, collectionId,brandCampaignId, searchTerm),
    getNextPageParam: (lastPage) => {
      if (lastPage?.hasNextPage) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    enabled: !!campaignCode,
    keepPreviousData: true,
  });
};

export const useCollections = () => {
  return useQuery({
    queryKey: ["collections"],
    queryFn: fetchCollections,
    staleTime: 1000 * 60 * 10,
  });
};

export const useBrandCampaigns = (query = {}) => {
  return useQuery({
    queryKey: ["brand-campaigns", query],
    queryFn: () => productService.getBrandCampaigns(query),
    staleTime: 1000 * 60 * 5, // 5 mins
    keepPreviousData: true,
  });
};